var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('i',{staticClass:"fas fa-exclamation-triangle text-warning missing-prepayment-warning",attrs:{"title":_vm.resolvedTooltip,"aria-label":_vm.resolvedTooltip,"role":"img"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }